import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useRentDetails, useRentPayments } from "../../CustomHooks/Queries";

import renderRentPaymentDetails from "../../Organisms/Modals/Pay Rent/rent-payment-details";

import { useModalContext } from "../../Contexts/ModalContext";

import { formatCurrency, formatDate } from "../../Utils/helpers";
import { longMonthDateFormat } from "../../Utils/constants";

import { DocumentHistory, InstantPayment, MultipleUsers, RecurringSchedule } from "../../Assets/Icons";

export default function RentPayment() {
  const navigate = useNavigate();

  const modalContext = useModalContext();

  const options = useMemo(() => {
    return [
      {
        optionName: "One-Time Payment",
        OptionIcon: InstantPayment,
        optionAction: () => navigate("/one-time-payment"),
      },
      {
        optionName: "Recurring Payment",
        OptionIcon: RecurringSchedule,
        optionAction: () => navigate("/recurring-payment"),
      },
      {
        optionName: "Manage Payees",
        OptionIcon: MultipleUsers,
        optionAction: () => navigate("/manage-payees"),
      },
    ];
  }, [navigate]);

  const { data: rentPayments } = useRentPayments();

  const { data: rentDetails } = useRentDetails();

  const isRentPaymentVisible = useMemo(() => {
    return rentDetails?.data?.data?.rent_payment?.is_rent_payment_visible;
  }, [rentDetails]);

  return isRentPaymentVisible || rentPayments?.length > 0 ? (
    <div className="rent-payments">
      {isRentPaymentVisible && (
        <div className="options-section">
          <div className="section-header mb-sm-6 mb-4">
            <div className="section-content">
              <div className="section-title">Rent Payments</div>
              <div className="section-description">Send rent now or set up recurring payments.</div>
            </div>
          </div>
          <div className="options">
            {options.map((option, index) => (
              <button key={index} className="option" onClick={option.optionAction}>
                <option.OptionIcon className="option-icon" />
                <div className="option-name">{option.optionName}</div>
              </button>
            ))}
          </div>
        </div>
      )}
      {rentPayments?.length > 0 && (
        <div className="payment-history-section">
          <div className="section-header mb-4">
            <div className="section-title">Rent Payment Activity</div>
            {rentPayments?.length > 2 && (
              <button className="see-all-button" onClick={navigate.bind(this, "/rent-payment-activity")}>
                View All
              </button>
            )}
          </div>
          {rentPayments?.length === 0 ? (
            <div className="no-records">
              <DocumentHistory className="icon" />
              Your payment history will appear here once you make your first payment.
            </div>
          ) : (
            rentPayments?.slice(0, 2)?.map((transaction, idx) => (
              <button
                key={idx}
                className="rent-transaction-activity"
                onClick={renderRentPaymentDetails.bind(this, modalContext, { paymentDetails: transaction })}
              >
                <div className="transfer-detail py-0">
                  <span className="transfer-date">{formatDate(transaction?.created_at, longMonthDateFormat)}</span>
                  <span className="transfer-value">{formatCurrency(transaction?.total)}</span>
                </div>
                <div className="transfer-detail py-0">
                  <span className="transaction-description">
                    {transaction?.type} payment to {transaction?.payee}
                  </span>
                  <div className={`transfer-status-badge ${transaction.statusType}`}>
                    <transaction.StatusIcon /> {transaction?.statusDisplayName}
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  ) : (
    <></>
  );
}
